<cer-form #form [panesDynamic]="true">
  <ng-template #topTemplate>
    <cer-form-pane pane="top">
    </cer-form-pane>
  </ng-template>
  <ng-template #leftTemplate>
    <cer-form-pane pane="left">
    </cer-form-pane>
  </ng-template>
  <ng-template #mainTemplate>
    <cer-form-pane pane="main">
    </cer-form-pane>
  </ng-template>
  <ng-template #rightTemplate>
    <cer-form-pane pane="right">
    </cer-form-pane>
  </ng-template>
  <ng-template #infoTemplate>
    <cer-form-pane pane="info">
    </cer-form-pane>
  </ng-template>
  <ng-template #bottomLeftTemplate>
    <cer-form-pane pane="bottomLeft">
    </cer-form-pane>
  </ng-template>
  <ng-template #bottomTemplate>
    <cer-form-pane pane="bottom">
    </cer-form-pane>
  </ng-template>
  <ng-template #bottomRightTemplate>
    <cer-form-pane pane="bottomRight">
    </cer-form-pane>
  </ng-template>
</cer-form>